import { api } from '../../Controllers/api'

const requestSites = () => {
  return {
    type: 'REQUEST_SITES',
    loading: true
  }
}

const receiveSites = data => {
  return {
    type: 'RECEIVE_SITES',
    payload: { data },
    loading: false
  }
}

const getSites = isRefresh => {
  return dispatch => {
    if (!isRefresh) {
      dispatch(requestSites())
    }
    api.get(`sites`).then(({ data }) => {
      dispatch(receiveSites(data))
    })
  }
}

export { getSites }
